import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState, useEffect, } from "react";
const ThemeContext = createContext(undefined);
export const ThemeProvider = ({ children }) => {
    const [colorScheme, setColorScheme] = useState(() => {
        try {
            const saved = localStorage.getItem("colorScheme");
            if (saved === "light" || saved === "dark") {
                return saved;
            }
        }
        catch {
            /* private mode / no storage */
        }
        // По умолчанию (для новых пользователей) — светлая тема.
        return "light";
    });
    const toggleColorScheme = () => {
        setColorScheme((prev) => (prev === "light" ? "dark" : "light"));
    };
    useEffect(() => {
        // `localStorage` может быть недоступен (см. LanguageProvider).
        // Гасим — иначе всплывёт через unhandledrejection и зашумит логи.
        try {
            localStorage.setItem("colorScheme", colorScheme);
        }
        catch {
            /* localStorage unavailable / quota — игнорируем */
        }
        // New design system reads `data-theme` on <html>; legacy code still
        // keys off `body.dark-mode`. Keep both in sync until the migration off
        // Mantine is complete.
        document.documentElement.setAttribute("data-theme", colorScheme);
        if (colorScheme === "dark") {
            document.body.classList.add("dark-mode");
        }
        else {
            document.body.classList.remove("dark-mode");
        }
    }, [colorScheme]);
    return (_jsx(ThemeContext.Provider, { value: {
            colorScheme,
            toggleColorScheme,
            setColorScheme,
        }, children: children }));
};
export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error("useTheme must be used within a ThemeProvider");
    }
    return context;
};
